<template>
  <div>
    <titulo-modulo titulo="Limite Conta Consumo" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <template v-else>
      <v-row v-if="limites.length > 0">
        <v-col cols="12">
          <v-card flat class="mb-2" v-for="(limite, i) in limites" :key="i">
            <v-card-title class="subtitle-1">{{
              limite.categoria
            }}</v-card-title>
            <v-card-subtitle class="title font-weight-bold green--text pb-0">{{
              formatoMoeda(limite.valorutilizado)
            }}</v-card-subtitle>

            <v-card-actions>
              <detalhes-conta-consumo
                v-if="limite.detalhes.length > 0"
                :limite="limite"
              />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-alert class="mt-3" text type="info" v-else>
        Não há informações sobre o limite consumido
      </v-alert>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import TituloModulo from "../../components/TituloModulo.vue";
import { formatMoeda } from "@/global";
import DetalhesContaConsumo from "./components/DetalhesContaConsumo.vue";

export default {
  components: { TituloModulo, DetalhesContaConsumo },
  data: () => ({
    carregando: false,
    limites: [],
  }),
  methods: {
    async getLimitesContaConsumo() {
      this.limites = [];
      await axios
        .get("/colaborador/financeiro?funcao=GASTOS-CONTA-CONSUMO")
        .then((res) => {
          if (res.data.success) {
            this.limites = res.data.data;
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
    },
    formatoMoeda(value) {
      return formatMoeda(value);
    },
  },
  async mounted() {
    this.carregando = true;
    await this.getLimitesContaConsumo();
    this.carregando = false;
  },
};
</script>

<style></style>
